import { renderPalletStatus } from "../../aplUtils/statusConditionEnumHelper";
import { Culture } from "../../types/culture";

export default function PalstatSearchStatusDropdown(props: {
    culture: Culture;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}) {
    let statuses = [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 30];

    return (
        <select className="form-control" id="searchStatus" name="searchStatus" onChange={props.onChange}>
            {statuses.map((key, idx) => {
                return <option key={key} value={key}>{renderPalletStatus(key, props.culture)}</option>;
            })}
        </select>
    );
}
